<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { getDeviceState } from 'src/stores/device-runtime/states';
	//Design system components
	import { Text, CircleAvatar } from '@Shelly/shelly-design-system';
	//Helpers
	import {
		getDeviceLastSeenData,
		getDeviceAvatarDefaultConfig,
	} from 'src/helpers/device_state_view_helpers';
	import {
		getCriticalNotifications,
		getNotificationsForDevice,
	} from 'src/helpers/notifications/device_notifications_helper';
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: settingsStore = getDeviceSettings(device?.id);
	$: status = $statusStore;
	$: settings = $settingsStore;

	$: notificationsToShow = getNotificationsForDevice(device?.id);
	$: criticalNotifications = getCriticalNotifications(notificationsToShow);

	$: lastSeenData = getDeviceLastSeenData(device, status, settings);

	$: deviceStateStore = getDeviceState(device?.id);
	$: deviceState = $deviceStateStore;
	$: notAuthenticated = deviceState?.type === 9; //wall display
	$: authLockedDevice = deviceState?.type === 5; //gen 2 devices
</script>

<CircleAvatar
	{...getDeviceAvatarDefaultConfig(device)}
	borderStatus={notAuthenticated || authLockedDevice
		? { icon: 'fa-solid fa-exclamation', color: 'color-warning' }
		: null}
/>

{#if notAuthenticated || authLockedDevice}
	<Text class="mb-s text-bold text-center">
		{$format('text_auth_device_required', {
			default: 'Authentication is required to access ‘{deviceName}’',
			values: { deviceName: device.name },
		})}.
	</Text>
	<Text class="text-color-muted text-center" styleType="body-small">
		{capFirstChar(
			$format('text_auth_device_description', {
				default: `Authenticate this device to ensure secure access.`,
			}),
		)}
	</Text>
{:else}
	<Text class="mb-s text-bold text-center">
		{$format('text_connected_to_device', {
			default: `Connected to ‘{deviceName}’.`,
			values: { deviceName: device.name },
		})}
		{#if criticalNotifications.length}
			{capFirstChar(criticalNotifications[0].name)}
			{$format('text_detected', { default: 'detected' })}.
		{/if}
	</Text>
	{#if lastSeenData.lastSeenUpdate}
		<Text class="text-color-muted text-center" styleType="body-small">
			{capFirstChar(
				$format('text_last_active', {
					default: `Last active: ${lastSeenData.time}.`,
					values: { time: lastSeenData.time },
				}),
			)}
		</Text>
	{/if}
{/if}
